import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default props => {
    const map = useMapContext()
    const {mapTypeCode, subTypeCode} = map.data

    if (! (
        'BODA2' === subTypeCode &&
        'SA_MAP' === mapTypeCode
    )) {
        return null
    }

    const onClick = () => {
        const [fa] = map.queryNodes({algo: 'bfs', data: {bizNodeType: 'FA'}})
        const {pkid, prjId, sVer} = fa.data

        openWindow(
            '/Ai',

            {
                dpIds: [pkid],
                prjId,
                scene: 'GENERATE_FA',
                sVer,
            }
        )
    }

    return {
        label: '新建功能结构',
        onClick,
        ...props,
    }
}
